import React from "react";
import { Container } from "react-bootstrap";
import { useConfiguration } from "@fdoh/api-client";

// TODO: Add config.copyrightYear to type and pass it down from env variables.

export const Footer: React.FC = () => {
  const config = useConfiguration();

  return (
    <Container className="py-3">
      <div className="row text-center align-items-center flex-row-reverse">
        <div className="col-lg-auto ms-lg-auto">
          <ul className="list-inline list-inline-dots mb-0 footer-links">
            {/* <li className="list-inline-item">
              <a
                href="http://www.myflorida.com/myflorida/privacy.html"
                className="link-secondary"
                target="_blank"
                rel="noreferrer"
              >
                Privacy
              </a>
            </li> */}
            <li className="list-inline-item">
              <a
                href="mailto:flehs_help@flhealth.gov?subject=Support%20Request&body=Please%20provide%20the%20following%20information,%20as%20well%20as%20any%20screenshots%20for%20your%20support%20request:%0A%0A---%0A%0AURL%20(if%20applicable):%20%0A%0AOperating%20System/Device:%20%0A%0AProblem%20Description:%20%0A%0ASteps%20to%20Reproduce%20(if%20applicable):%20%0A%0AError%20Messages%20(if%20any):%20%0A%0A---%0A%0AThank%20you."
                className="link-secondary"
                rel="noreferrer"
              >
                Support
              </a>
            </li>
            <li className="list-inline-item">
              <a
                href="http://www.floridahealth.gov/disclaimer.html"
                className="link-secondary"
                target="_blank"
                rel="noreferrer"
              >
                Disclaimer
              </a>
            </li>
            <li className="list-inline-item">
              <a
                href="http://www.floridahealth.gov/accessibility-information.html"
                className="link-secondary"
                target="_blank"
                rel="noreferrer"
              >
                Accessibility
              </a>
            </li>
          </ul>
        </div>
        <div className="col-12 col-lg-auto mt-3 mt-lg-0 footer-copyright">
          <span className="text-nowrap link-secondary">v{config.version}</span>
          <span className="mx-2 footer-separator">·</span>
          <span className="text-nowrap">Copyright © 2026</span>
          {/* {config.copyrightYear ?? new Date().getFullYear()} */}{" "}
          <span className="text-nowrap">
            <a
              href="https://www.floridahealth.gov"
              className="link-secondary"
              target="_blank"
              rel="noreferrer"
            >
              Florida Department of Health
            </a>
            .
          </span>{" "}
          <span className="text-nowrap">All rights reserved.</span>
        </div>
      </div>
    </Container>
  );
};
